import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InputSelect } from 'components/atoms'
import { DebugBarComponent } from 'components/organisms'
import { secondsToHms } from 'utils'

const DebugBar = ({
  debugBool,
  screens,
  screenSelected,
  onScreenChange,
  contentAttributes,
  isPassiveMode,
  countDown,
  zone,
}) => {
  const [isOpened, setIsOpened] = useState(debugBool)
  const { contentType, layout: { layoutName, brand } = {} } = contentAttributes

  return (
    <DebugBarComponent isOpened={isOpened} onClose={() => setIsOpened(false)}>
      {zone && <p>Zone id: {zone}</p>}
      <p>{!screenSelected && 'Screen not registered'}</p>
      {contentType ? <p>Content type: {contentType}</p> : <p>No content types assigned</p>}
      {layoutName && (
        <p>
          Layout: {brand} - {layoutName}
        </p>
      )}
      <p>Mode: {isPassiveMode ? 'passive' : 'active'}</p>
      {countDown > 0 && <p>Time to passive mode: {secondsToHms(countDown)}</p>}
      <InputSelect
        name={'Screen selection'}
        placeholder={'Select screen'}
        value={screenSelected}
        options={screens}
        errorMsg={'Campo obligatorio'}
        isDisabled={false}
        isSearchable={true}
        handleChange={onScreenChange}
        top={'top'}
      />
    </DebugBarComponent>
  )
}

DebugBar.defaultProps = {
  debugBool: false,
  screens: [],
  onScreenChange: () => {},
  contentAttributes: {},
  zone: null,
}

DebugBar.propTypes = {
  debugBool: PropTypes.bool,
  screens: PropTypes.array,
  screenSelected: PropTypes.object,
  onScreenChange: PropTypes.func,
  contentAttributes: PropTypes.object,
  isPassiveMode: PropTypes.bool.isRequired,
  countDown: PropTypes.number.isRequired,
  zone: PropTypes.number,
}

export default DebugBar
